import React, { useState } from 'react';
import '../styles/FormulairePage.css';
import Notification from '../components/Notification';

function FormulairePage({ onBack, onShowDemand }) {
  const [formData, setFormData] = useState({
    // Identité (obligatoires)
    nom: '',
    postnom: '',
    prenom: '',
    adresse: '',
    // Contact (obligatoires)
    email: '',
    telephone: '',
    // Établissement (optionnel)
    nom_etablissement: '',
    email_etablissement: '',
    statut_juridique: '',
    // Matricule ESU (optionnel)
    matricule_esu: '',
    // Commentaires (optionnel)
    commentaires: '',
  });

  const [files, setFiles] = useState({
    // Fichiers obligatoires
    preuve_paiement: null,
    // Fichiers optionnels
    lettre_demande: null,
    copie_diplome: null,
    releves_cotes: null,
    titre_academique_rdc: null,
    baccalaureat: null,
    composition_jury: null,
    pv_soutenance: null,
    titre_sejour: null,
    documents_version_francaise: null,
  });

  const [notification, setNotification] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const showNotification = (message, type = 'info', duration = 5000) => {
    setNotification({ message, type });
    setTimeout(() => setNotification(null), duration);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleFileChange = (e) => {
    const { name, files: fileList } = e.target;
    setFiles(prev => ({
      ...prev,
      [name]: fileList[0] || null
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    
    // Créer un FormData pour l'envoi multipart
    const formDataToSend = new FormData();
    
    // Ajouter les champs texte
    Object.keys(formData).forEach(key => {
      if (formData[key]) {
        formDataToSend.append(key, formData[key]);
      }
    });
    
    // Ajouter les fichiers
    Object.keys(files).forEach(key => {
      if (files[key]) {
        formDataToSend.append(key, files[key]);
      }
    });
    
    // Log des données envoyées
    console.log('=== DONNÉES ENVOYÉES À L\'API ===');
    console.log('Champs texte:', formData);
    console.log('Fichiers:', files);
    console.log('FormData complet:');
    for (let pair of formDataToSend.entries()) {
      if (pair[1] instanceof File) {
        console.log(`  ${pair[0]}: [File] ${pair[1].name} (${pair[1].size} bytes)`);
      } else {
        console.log(`  ${pair[0]}: ${pair[1]}`);
      }
    }
    console.log('================================');
    
    try {
      const response = await fetch('https://admin.cgiibnn-esursi.cd/api/equivalences/', {
        method: 'POST',
        body: formDataToSend,
      });
      
      if (response.ok) {
        const data = await response.json();
        console.log('✓ RÉPONSE SUCCÈS DE L\'API:');
        console.log('  Numéro de demande:', data.numero_demande);
        console.log('  Statut:', data.statut);
        console.log('  Date soumission:', data.date_soumission);
        console.log('  Données complètes:', data);
        showNotification(
          `Votre demande a été enregistrée avec succès!\nNuméro de demande: ${data.numero_demande}`,
          'success',
          6000
        );
        
        // Réinitialiser le formulaire
        setFormData({
          nom: '',
          postnom: '',
          prenom: '',
          adresse: '',
          email: '',
          telephone: '',
          nom_etablissement: '',
          email_etablissement: '',
          statut_juridique: '',
          matricule_esu: '',
          commentaires: '',
        });
        setFiles({
          preuve_paiement: null,
          lettre_demande: null,
          copie_diplome: null,
          releves_cotes: null,
          titre_academique_rdc: null,
          baccalaureat: null,
          composition_jury: null,
          pv_soutenance: null,
          titre_sejour: null,
          documents_version_francaise: null,
          composition_jury: null,
          titre_sejour: null,
          version_francaise: null,
          preuve_paiement: null,
        });
        
        // Réinitialiser les champs de fichiers du DOM
        const fileInputs = document.querySelectorAll('input[type="file"]');
        fileInputs.forEach(input => input.value = '');
        
      } else {
        const errorData = await response.json();
        const errorMessage = errorData.detail || 'Échec de la soumission. Veuillez vérifier vos données.';
        console.error('✕ ERREUR DE L\'API (Status:', response.status + ')');
        console.error('  Message:', errorMessage);
        console.error('  Données d\'erreur complètes:', errorData);
        showNotification(`Erreur: ${errorMessage}`, 'error', 7000);
      }
    } catch (error) {
      console.error('✕ ERREUR DE CONNEXION:', error);
      showNotification(
        'Erreur de connexion au serveur. Vérifiez que le serveur est en cours d\'exécution sur http://localhost:8000',
        'error',
        7000
      );
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      {notification && (
        <Notification
          message={notification.message}
          type={notification.type}
          onClose={() => setNotification(null)}
        />
      )}
      
      <header className="app-header">
        <img src="/app-logo.png" alt="app logo" className="app-logo-header" />
        <h1 className="header-title">Demande d'Équivalence</h1>
        <button className="btn-see-demand" onClick={onShowDemand}>
          <i className="bi bi-eye"></i> Voir votre demande
        </button>
      </header>
      
      <div className="formulaire-container">
        <form className="formulaire" onSubmit={handleSubmit}>
          
          {/* Section Identité et Adresse */}
          <div className="formulaire-section">
            <h2 className="section-title">1. Identité du Requérant</h2>
            
            <div className="form-group">
              <label htmlFor="nom">Nom <span className="required">*</span></label>
              <input
                type="text"
                id="nom"
                name="nom"
                value={formData.nom}
                onChange={handleChange}
                required
                className="form-input"
              />
            </div>

            <div className="form-group">
              <label htmlFor="postnom">Post-nom <span className="required">*</span></label>
              <input
                type="text"
                id="postnom"
                name="postnom"
                value={formData.postnom}
                onChange={handleChange}
                required
                className="form-input"
              />
            </div>

            <div className="form-group">
              <label htmlFor="prenom">Prénom</label>
              <input
                type="text"
                id="prenom"
                name="prenom"
                value={formData.prenom}
                onChange={handleChange}
                className="form-input"
              />
            </div>

            <div className="form-group">
              <label htmlFor="adresse">Adresse <span className="required">*</span></label>
              <input
                type="text"
                id="adresse"
                name="adresse"
                value={formData.adresse}
                onChange={handleChange}
                required
                className="form-input"
              />
            </div>

            <div className="form-group">
              <label htmlFor="matricule_esu">Matricule ESU</label>
              <input
                type="text"
                id="matricule_esu"
                name="matricule_esu"
                value={formData.matricule_esu}
                onChange={handleChange}
                className="form-input"
              />
            </div>
          </div>

          {/* Section Coordonnées */}
          <div className="formulaire-section">
            <h2 className="section-title">2. Coordonnées de Contact</h2>
            
            <div className="form-group">
              <label htmlFor="email">Adresse e-mail du requérant <span className="required">*</span></label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
                className="form-input"
              />
            </div>

            <div className="form-group">
              <label htmlFor="telephone">Numéro de téléphone du requérant <span className="required">*</span></label>
              <input
                type="tel"
                id="telephone"
                name="telephone"
                value={formData.telephone}
                onChange={handleChange}
                required
                className="form-input"
              />
            </div>
          </div>

          {/* Section Établissement */}
          <div className="formulaire-section">
            <h2 className="section-title">3. Informations de l'Établissement</h2>
            
            <div className="form-group">
              <label htmlFor="nom_etablissement">Nom de l'établissement</label>
              <input
                type="text"
                id="nom_etablissement"
                name="nom_etablissement"
                value={formData.nom_etablissement}
                onChange={handleChange}
                className="form-input"
              />
            </div>

            <div className="form-group">
              <label htmlFor="email_etablissement">Adresse email de l'établissement</label>
              <input
                type="email"
                id="email_etablissement"
                name="email_etablissement"
                value={formData.email_etablissement}
                onChange={handleChange}
                className="form-input"
              />
            </div>

            <div className="form-group">
              <label htmlFor="statut_juridique">Statut juridique de l'établissement</label>
              <select
                id="statut_juridique"
                name="statut_juridique"
                value={formData.statut_juridique}
                onChange={handleChange}
                className="form-input"
              >
                <option value="">-- Sélectionner un statut --</option>
                <option value="universite_publique">Université publique</option>
                <option value="universite_privee">Université privée</option>
                <option value="ecole_superieure">École supérieure</option>
                <option value="autre">Autre</option>
              </select>
            </div>
          </div>

          {/* Section Lettre de Demande */}
          <div className="formulaire-section">
            <h2 className="section-title">4. Lettre de Demande d'Équivalence</h2>
            <div className="form-group">
              <label htmlFor="lettre_demande">Lettre de demande d'équivalence adressée à Son Excellence Madame la Ministre du MINESURSI</label>
              <input
                type="file"
                id="lettre_demande"
                name="lettre_demande"
                onChange={handleFileChange}
                accept=".pdf"
                className="form-input-file"
              />
            </div>
          </div>

          {/* Section Documents Académiques */}
          <div className="formulaire-section">
            <h2 className="section-title">5. Documents Académiques</h2>
            
            <div className="form-group">
              <label htmlFor="copie_diplome">Photocopie du diplôme pour lequel l'équivalence est sollicitée</label>
              <input
                type="file"
                id="copie_diplome"
                name="copie_diplome"
                onChange={handleFileChange}
                accept=".pdf"
                className="form-input-file"
              />
            </div>

            <div className="form-group">
              <label htmlFor="releves_cotes">Relevés des côtes et/ou titres académiques intermédiaires obtenus</label>
              <input
                type="file"
                id="releves_cotes"
                name="releves_cotes"
                onChange={handleFileChange}
                accept=".pdf"
                className="form-input-file"
              />
            </div>

            <div className="form-group">
              <label htmlFor="titre_academique_rdc">Dernier titre académique obtenu en RDC</label>
              <input
                type="file"
                id="titre_academique_rdc"
                name="titre_academique_rdc"
                onChange={handleFileChange}
                accept=".pdf"
                className="form-input-file"
              />
            </div>

            <div className="form-group">
              <label htmlFor="baccalaureat">Diplômes d'Etat/baccalauréat</label>
              <input
                type="file"
                id="baccalaureat"
                name="baccalaureat"
                onChange={handleFileChange}
                accept=".pdf"
                className="form-input-file"
              />
            </div>

            <div className="form-group">
              <label htmlFor="composition_jury">Composition du jury et, s'il échet le PV de délibération de la soutenance</label>
              <input
                type="file"
                id="composition_jury"
                name="composition_jury"
                onChange={handleFileChange}
                accept=".pdf"
                className="form-input-file"
              />
            </div>

            <div className="form-group">
              <label htmlFor="pv_soutenance">PV de délibération de soutenance</label>
              <input
                type="file"
                id="pv_soutenance"
                name="pv_soutenance"
                onChange={handleFileChange}
                accept=".pdf"
                className="form-input-file"
              />
            </div>

            <div className="form-group">
              <label htmlFor="titre_sejour">Titre(s) de séjour, visa d'études ou photocopie du passeport pour les étrangers</label>
              <input
                type="file"
                id="titre_sejour"
                name="titre_sejour"
                onChange={handleFileChange}
                accept=".pdf"
                className="form-input-file"
              />
            </div>

            <div className="form-group">
              <label htmlFor="documents_version_francaise">Version française de tout document existant dans une autre langue</label>
              <input
                type="file"
                id="documents_version_francaise"
                name="documents_version_francaise"
                onChange={handleFileChange}
                accept=".pdf"
                className="form-input-file"
              />
            </div>
          </div>

          
          {/* SECTION PAIEMENT - COMMENTÉE */}
          
          {/* Section Commentaires */}
          <div className="formulaire-section">
            <h2 className="section-title">6. Commentaires (Optionnel)</h2>
            
            <div className="form-group">
              <label htmlFor="commentaires">Commentaires supplémentaires</label>
              <textarea
                id="commentaires"
                name="commentaires"
                value={formData.commentaires}
                onChange={handleChange}
                className="form-input"
                rows="5"
                placeholder="Veuillez ajouter d'éventuels commentaires..."
              />
            </div>
          </div>

          {/* Boutons d'action */}
          <div className="formulaire-actions">
            <button type="button" className="btn-back" onClick={onBack} disabled={isLoading}>
              ← RETOUR
            </button>
            <button type="submit" className="btn-submit" disabled={isLoading}>
              {isLoading ? 'Envoi en cours...' : 'SOUMETTRE LA DEMANDE'}
            </button>
          </div>
        </form>
      </div>
    </>
  );
}

export default FormulairePage;
